import { useDispatch } from "react-redux";

import { setMetaAction } from "./../../redux/actions/metaActions/metaActions";

const GetMetaButton = () => {
  const dispatch = useDispatch();

  return (
    <div className="text-center">
      <button className="kf-btn" onClick={() => dispatch(setMetaAction())}>
        <span>دریافت مجدد اطلاعات</span>
      </button>
    </div>
  );
};

export default GetMetaButton;
